// for now it will be used only in specific cases, in the future it will be moved in the global styles
export const focusStyles = {
    ':focus': {
        // TODO (Jamal) investigate type for colors
        boxShadow: ({ colors }) => `0 0 0 4px ${colors.baseBorderWeakActive}`,
        outline: 'transparent solid 4px',
    },
    // this will make sure that the focus UI will be visible only when the element has keyboard navigation focus
    // not when it's clicked
    ':focus:not(:focus-visible)': {
        boxShadow: 'none',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9jdXNTdHlsZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9jb21tb25zL2ZvY3VzU3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLHNHQUFzRztBQUN0RyxNQUFNLENBQUMsTUFBTSxXQUFXLEdBQXVCO0lBQzdDLFFBQVEsRUFBRTtRQUNSLDJDQUEyQztRQUMzQyxTQUFTLEVBQUUsQ0FBQyxFQUFFLE1BQU0sRUFBRSxFQUFFLEVBQUUsQ0FBQyxhQUFhLE1BQU8sQ0FBQyxvQkFBb0IsRUFBRTtRQUN0RSxPQUFPLEVBQUUsdUJBQXVCO0tBQ2pDO0lBQ0QsNEdBQTRHO0lBQzVHLHdCQUF3QjtJQUN4Qiw0QkFBNEIsRUFBRTtRQUM1QixTQUFTLEVBQUUsTUFBTTtLQUNsQjtDQUNGLENBQUMifQ==